import { styled } from "goober";
import type { ReactNode } from "react";
import { Button } from "./Button";
import { Modal } from "./Modal";
import { Text } from "./Text";

const Content = styled("div")`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 320px;
`;

const Footer = styled("div")`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: ReactNode;
  confirmLabel: string;
  destructive?: boolean;
  pending?: boolean;
  confirmDisabled?: boolean;
  children?: ReactNode;
};

export function ConfirmModal({
  open,
  onClose,
  onConfirm,
  title,
  description,
  confirmLabel,
  destructive,
  pending,
  confirmDisabled,
  children,
}: Props) {
  return (
    <Modal
      open={open}
      onClose={() => {
        if (!pending) onClose();
      }}
      alert
    >
      <Content>
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <Text variant="text-regular-md" color="var(--text-primary)">
            {title}
          </Text>
          <Text variant="text-regular" color="var(--text-secondary)">
            {description}
          </Text>
        </div>
        {children}
        <Footer>
          <Button
            size="l"
            variant="subtle"
            onClick={onClose}
            disabled={pending}
          >
            Cancel
          </Button>
          <Button
            size="l"
            variant={destructive ? "danger" : "primary"}
            onClick={onConfirm}
            disabled={pending || confirmDisabled}
            aria-busy={pending}
          >
            {confirmLabel}
          </Button>
        </Footer>
      </Content>
    </Modal>
  );
}
